<template>
    <div class="text-a-blue-001b73" data-cy="container_confirm_redeem_interface">
        <div class="text-22 font-medium mb-2" data-cy="text_confirm_redeem_interface_title">{{title}}</div>
        <p class="text-16 font-regular" data-cy="text_confirm_redeem_interface_msg" v-html="msg"></p>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'InterfaceConfirmRedeem',
    mixins: [LocaleMixin],
    props: {
        campaign: Object
    },
    data: function () {
        return {
            title: '',
            msg: ''
        };
    },
    created: function () {
        this.title = this.lbl.confirm_redeem.interface;
        this.redeemPoint();
    },
    methods: {
        redeemPoint: function() {
            let point = this.FilterNumberFormat(this.campaign.pointPerUnit);
            this.msg = this.FilterStringFormat(this.lbl.confirm_redeem.msg_interface, point);
        }
    }
}
</script>
